

export const requestModes: string[] = ["default", "cors", "no-cors", "same-origin"];

export enum CachingStrategy {

  CacheFirst = "cacheFirst",
  CacheNetwork = "cacheNetwork",
  NetworkFirst = "networkFirst",
  NetworkOnly = "networkOnly",
  CacheOnly = "cacheOnly"
}

export enum MimeTypes {
  js = "text/javascript",
  json = "application/json",
  map = "application/json",
  css = "text/css",
  eot = "application/vnd.ms-fontobject",
  otf = "application/x-font-otf",
  ttf = "application/x-font-ttf",
  woff = "application/x-font-woff",
  woff2 = "application/font-woff2",
  ico = "image/x-icon",
  gif = "image/gif",
  jpg = "image/jpeg",
  jpeg = "image/jpeg",
  png = "image/png",
  webp = "image/webp",
  avif = "image/avif",
  svg = "image/svg+xml",
  swf = "application/x-shockwave-flash",
  txt = "text/plain",
  xml = "text/xml",
  pdf = "application/pdf",
  mp3 = 'audio/mpeg',
  htm = 'text/html',
  html = 'text/html'
}

export const PORTAL = 'ADMIN';

export const encrptionPrivateKey = "e93jGXDcjXPbSOAE";